(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gb-gully-home"] && !Shopify.designMode) return;
  try {
    
  const initializeGullyHome = (root) => {
    if (!root || root.dataset.gbgReady === 'true') return;
    root.dataset.gbgReady = 'true';

    const tabs = [...root.querySelectorAll('[data-gbg-tab]')];
    const panels = [...root.querySelectorAll('[data-gbg-panel]')];

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const update = () => {
          tabs.forEach((item) => {
            const active = item === tab;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-selected', active ? 'true' : 'false');
          });

          panels.forEach((panel) => {
            const active = panel.dataset.gbgPanel === tab.dataset.gbgTab;
            panel.classList.toggle('is-active', active);
            panel.hidden = !active;
          });
        };

        if (document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          document.startViewTransition(update);
        } else {
          update();
        }
      });
    });
  };

  document.querySelectorAll('[data-gb-gully-home]').forEach(initializeGullyHome);
  document.addEventListener('shopify:section:load', (event) => initializeGullyHome(event.target.querySelector('[data-gb-gully-home]')));

  } catch(e) { console.error(e); }
})();
})();
